import React from 'react';

import { CloseIcon } from 'components/Icons';

import styles from './NotificationCloseButton.module.scss';

export interface NotificationCloseButtonProps {
  closeToast: () => void;
}

const NotificationCloseButton = ({ closeToast }: NotificationCloseButtonProps) => {
  return (
    <div onClick={closeToast} className={styles.container}>
      <CloseIcon className={styles.closeIcon} />
    </div>
  );
};

export default NotificationCloseButton;
